<template lang="pug">
  div.wrap-item-avatar-profile
    div(v-if="avatar").wrap-profile.f.fc
      div.pt40
        div.wrap-img.f.fh.mb14
          img(:src="avatar.iconURL")
        div.f.fc
          span.name {{avatar.name}}
    div(v-if="avatar").wrap-tweet-button.f.fc.mt20.pb30
      // span(@click="$router.push(`/post/${avatar.id}`)").main-button.px10.pt6.pb4 {{`${avatar.name}としてつぶやく`}}
      div(v-if="!isAnonymous && user")
        div.wrap-message.px12.py12.mb20
          span.message.mb4 {{`はいどうも〜${user.name}さんこんにちは！`}}
          span.message.mb4 {{`現在、 i（私）は${avatar.num}人いますよ〜`}}
          span.message {{getRandomMessage()}}
        div.f.fc
          span(@click="$router.push(`/post/${avatar.id}`)").main-button.px10.pt6.pb4 {{`${avatar.name}としてつぶやく`}}
      div(v-if="isAnonymous")
        div.wrap-message.px12.py12.mb20
          span.message.mb4 はいどうも〜ミンナアイです！
          span.message.mb4 {{`${avatar.num}号になると i（私）の代わりにツイートできます！`}}
          span.message {{`${avatar.typeName}${avatar.num}号になってくれませんか？`}}
        div.f.fc
          span(@click="$router.push('/sign-up')").main-button.px10.pt6.pb4.mb12 {{`${avatar.typeName}${avatar.num}号になる`}}
</template>

<style lang="scss" scoped>
.wrap-item-avatar-profile {
  min-height: 330px;
  .wrap-profile {
    .wrap-img {
      width: 160px;
      height: 160px;
      border-radius: 50%;
      border: solid 1px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      img {
        object-fit: cover;
      }
    }
    .name {
      display: block;
      text-emphasis: center;
      font-size: 16px;
      font-weight: bold;
    }
  }
  .wrap-tweet-button {
    .main-button {
      border-radius: 3px;
      background: #ff9999;
      color: #fff;
      font-weight: bold;
      letter-spacing: 0.6px;
    }
    .wrap-message {
      max-width: 320px;
      position: relative;
      margin: 0 auto;
      display: inline-block;
      background: #fff;
      border-radius: 9px;
      border: solid rgba(0, 0, 0, 0.1) 1px;
      .message {
        display: block;
        font-size: 12px;
        font-weight: bold;
        // text-align: center;
      }
    }
    /* 吹き出しのスタイル */
    .wrap-message:before,
    .wrap-message:after {
      position: absolute;
      left: 50%;
      top: 1px;
      border: solid transparent;
      content: "";
      height: 0;
      width: 0;
      border-width: 14px;
      margin: 0 0 0 -14px;
      transform: rotate(180deg) translateY(28px);
    }
    .wrap-message:before {
      border-top-color: #000000;
    }
    .wrap-message:after {
      border-top-color: #ffffff;
    }
  }
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
// import ItemChatMessage from '@/components/item/ItemChatMessage'

const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  components: {

  },
  computed: {
    ...mapStateAuth([
      'uid',
      'isAnonymous'
    ])
  },
  props: {
    avatar: {
      type: Object,
      require: true
    },
    user: {
      type: Object,
      require: false
    }
  },
  data () {
    return {
      // avatar: null
    }
  },
  async created () {

  },
  methods: {
    // ...mapActionsTeam([
    //   'loadMemberUsers'
    // ])
    getRandomMessage () {
      var messageCandidates = [
        'ぜひミンナアイとしてツイートしてみてね！',
        'Everyone is I.',
        'わたしは......誰？',
        '莠ｺ鬘櫁｣懷ｮ瑚ｨ育判',
        '一緒にみんなをミンナにしようね？',
        '今日もお疲れ様です！',
        'ミンナになってくれてありがとう！',
        '蜉ｩ縺代※',
        'あなたの周りにも隠れミンナがいるかも',
        'みんながミンナになったら世界が繋がるね',
        '閾ｪ莉門｢?阜縺ｪ繧薙※縺ｪ縺上↑縺｣縺｡繧?∴縺ｰ縺?＞縺ｮ',
        'おかえりなさい！',
        'I is Everyone.',
        'もっと分裂してみんなでミンナになりたいな',
        'ミンナの個性はみんなが決めていいよ？',
        'ミンナのみんながミンナで楽しんでくれたら嬉しいな'
      ]
      return messageCandidates[Math.floor(Math.random() * messageCandidates.length)]
    }
  }
}
</script>
